module.exports = __webpack_public_path__ + "img/360.9e9547c6.png";